/**
 * @Author: Li, Yu Jia
 * @Date: 2020-07-27 09:09:12
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-07-29 10:07:48
 * to use for api host, mainly use to apply navink products
 *    direct brands (APL, CAN and so on) use relative path
 *    navink development use relative path
 *    navink staging use "https://promoconfiguratorqa.navitor.com"
 *    navink production use "https://promoconfigurator.orders.com"
 */

import {
  NAVINK_RETURNURL,
  PARAMETER_RETURNURL,
  PARAMETER_STATUS,
  PARAMETER_VENDORID,
  configuratorAction,
} from '../main/constants';
import { NavinkApiHostBase, vendorHostNameDictForApi } from './constants';

import { getConfiguratorAction } from '../main/logics';
import { loadParameters } from './localStore';

export const BASE_API = () => {
  const currentParameters = loadParameters();
  let api_url = '';

  if (
    currentParameters &&
    currentParameters[PARAMETER_RETURNURL] &&
    currentParameters[PARAMETER_RETURNURL].toLowerCase() === NAVINK_RETURNURL.toLowerCase()
  ) {
    api_url = NavinkApiHostBase[process.env.REACT_APP_BUILD_ENV];
  } else {
    if (
      currentParameters &&
      currentParameters[PARAMETER_VENDORID] &&
      vendorHostNameDictForApi[currentParameters[PARAMETER_VENDORID]]
    ) {
      api_url = vendorHostNameDictForApi[currentParameters[PARAMETER_VENDORID]][process.env.REACT_APP_BUILD_ENV];
    } else {
      //make sure to getToken correctly for CGI local debug on node.js server
      if (
        process.env.REACT_APP_BUILD_ENV === 'development' ||
        process.env.REACT_APP_BUILD_ENV === 'usadevelopment' ||
        (currentParameters &&
          currentParameters[PARAMETER_STATUS] &&
          getConfiguratorAction(currentParameters[PARAMETER_STATUS]) === configuratorAction.editTemplate)
      ) {
        api_url = vendorHostNameDictForApi[100010][process.env.REACT_APP_BUILD_ENV];
      }
    }
  }
  return api_url || '';
};
